import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import { uploadClass } from './styles';
import icons from '../icons';
import RemoveConfirm from './RemoveConfirm';
import { getDirectionClass } from '../utils/classname';
var DefaultProps = {
  renderResult: function renderResult(a) {
    return a;
  },
  recoverAble: false
};

var Result =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Result, _PureComponent);

  var _super = _createSuper2(Result);

  function Result(props) {
    var _this;

    _classCallCheck(this, Result);

    _this = _super.call(this, props);
    _this.state = {
      confirm: false
    };
    _this.handleRemove = _this.handleRemove.bind(_assertThisInitialized(_this));
    _this.handleRecover = _this.handleRecover.bind(_assertThisInitialized(_this));
    _this.handleConfirmChange = _this.handleConfirmChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Result, [{
    key: "handleRemove",
    value: function handleRemove() {
      if (this.props.onRemove) this.props.onRemove(this.props.index);
    }
  }, {
    key: "handleRecover",
    value: function handleRecover() {
      var _this$props = this.props,
          onRecover = _this$props.onRecover,
          value = _this$props.value,
          index = _this$props.index;
      if (onRecover) onRecover(index, value);
    }
  }, {
    key: "handleConfirmChange",
    value: function handleConfirmChange(confirm) {
      this.setState({
        confirm: confirm
      });
    }
  }, {
    key: "render",
    value: function render() {
      var confirm = this.state.confirm;
      var _this$props2 = this.props,
          _this$props2$renderRe = _this$props2.renderResult,
          renderResult = _this$props2$renderRe === void 0 ? DefaultProps.renderResult : _this$props2$renderRe,
          value = _this$props2.value,
          recoverAble = _this$props2.recoverAble,
          showRecover = _this$props2.showRecover,
          removeConfirm = _this$props2.removeConfirm;
      var className = uploadClass('view-value', recoverAble && 'to-be-delete', confirm && 'view-active');
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: className
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: uploadClass(getDirectionClass('text'))
        }, renderResult(value)), this.props.onRemove &&
        /*#__PURE__*/
        React.createElement("a", {
          className: uploadClass('delete'),
          onClick: removeConfirm ? undefined : this.handleRemove
        }, icons.Close,
        /*#__PURE__*/
        React.createElement(RemoveConfirm, {
          onVisibleChange: this.handleConfirmChange,
          confirm: removeConfirm,
          onRemove: this.handleRemove
        })), showRecover &&
        /*#__PURE__*/
        React.createElement("a", {
          className: uploadClass('recover'),
          onClick: this.handleRecover
        }, icons.Recovery))
      );
    }
  }]);

  return Result;
}(PureComponent);

Result.defaultProps = DefaultProps;
export default Result;